<div class="full-width" fxLayout="column" fxLayoutGap="10px">
  @if (unavailableSpaceSelected && warnOnUnavailableSelection) {
    <app-info-panel
      [message]="['You have selected one or more spaces that are not available for the full selected date range. Please update either your period type or selected dates.']"
      [type]="PanelType.ERROR"></app-info-panel>
  } @else if (availableSpaces.partiallyAvailable.length > 0) {
    <app-info-panel
      [message]="['The list shown includes one or more spaces that are not available for the full selected date range.']"
      [type]="PanelType.WARN"></app-info-panel>
  }

  <ng-template mat-tab-label>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
      <div class="square-icon icon-smaller">
        <mat-icon svgIcon="stacked_lines"></mat-icon>
      </div>
      <span class="body-1-default">Available Spaces</span>
    </div>
  </ng-template>
  <div class="spaces-list full-width"
       [style.height]="listHeight">
    @if (availableSpaces.fullyAvailable.length > 0) {
      <span class="body-3-default">Fully available spaces</span>
      <div *ngFor="let space of availableSpaces.fullyAvailable"
           class="space-item" fxLayout="row" fxLayoutAlign="space-between start"
           [class.selected]="isSpaceSelected(space.id)"
           (click)="onSelectSpace.emit(space.id)">
        <div class="space-details">
          <h3>{{ space.spaceName }}</h3>
          <div class="space-info">
            <mat-icon>location_on</mat-icon>
            {{ space.spaceLocation }}
          </div>
          <div class="space-info">
            <mat-icon>crop_square</mat-icon>
            {{ space.spaceSize }}m²
          </div>
        </div>
        <div class="space-pricing" fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="5px">
          <mat-chip-set style="height: 32px">
            @for (industry of space.districtSpacesIndustries; track industry) {
              <mat-chip class="m-0" style="height: 24px">
                <span class="body-1-default">{{ displayIndustry(industry) }}</span>
              </mat-chip>
            }
          </mat-chip-set>

          @if (!hasPricing(space)) {
            <div class="heading-regular">No pricing for space</div>
          } @else {
            @for (pricing of getSpacePricing(space); track pricing) {
              <div class="price">{{ pricing }}</div>
            }
            @if (getMonthlyPricing(space)) {
              <div class="body-2-default">R {{ getMonthlyPricing(space) }}/month</div>
            }
          }

        </div>
      </div>
    }

    @if (availableSpaces.partiallyAvailable.length > 0) {
      <span class="body-3-default">Partially available spaces</span>

      <div *ngFor="let space of availableSpaces.partiallyAvailable"
           class="space-item" fxLayout="row" fxLayoutAlign="space-between start"
           [class.selected]="isSpaceSelected(space.id)"
           (click)="onSelectSpace.emit(space.id)">
        <div class="space-details">
          <h3>{{ space.spaceName }}</h3>
          <div class="space-info">
            <mat-icon>location_on</mat-icon>
            {{ space.spaceLocation }}
          </div>
          <div class="space-info">
            <mat-icon>crop_square</mat-icon>
            {{ space.spaceSize }}m²
          </div>
        </div>
        <div class="space-pricing partial-spacing" fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="5px">
          <mat-chip-set style="height: 32px">
            @for (industry of space.districtSpacesIndustries; track industry) {
              <mat-chip class="m-0" style="height: 24px;">
                <span class="body-1-default">{{ displayIndustry(industry) }}</span>
              </mat-chip>
            }
          </mat-chip-set>

          @if (!hasPricing(space)) {
            <div class="heading-regular">No pricing for space</div>
          } @else {
            @for (pricing of getSpacePricing(space); track pricing) {
              <div class="price">{{ pricing }}</div>
            }
            @if (getMonthlyPricing(space)) {
              <div class="body-2-default">R {{ getMonthlyPricing(space) }}/month</div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
